import dayjs from 'dayjs';

const getBirthDateFromIIN = (iin) => {
  const year = (iin.substring(0, 2) >= 20 ? 1900 : 2000) + Number(iin.substring(0, 2));
  const month = Number(iin.substring(2, 4)) - 1;
  const day = Number(iin.substring(4, 6));
  return dayjs(new Date(year, month, day)).format('DD.MM.YYYY');
};

export default getBirthDateFromIIN;